import type * as Types from '../../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type AutocompleteHashtagsQueryVariables = Types.Exact<{
  text: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type AutocompleteHashtagsQuery = {
  __typename?: 'Query';
  results?: Array<{ __typename?: 'Hashtag'; id: string; name: string; zoom?: number | null }> | null;
};

export type AutocompletePlacesQueryVariables = Types.Exact<{
  text: Types.Scalars['String']['input'];
  sessionId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  longitude?: Types.InputMaybe<Types.Scalars['String']['input']>;
  latitude?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type AutocompletePlacesQuery = {
  __typename?: 'Query';
  results?: Array<{
    __typename?: 'Place';
    id: string;
    name: string;
    isRegion?: boolean | null;
    isProvince?: boolean | null;
    isMunicipality?: boolean | null;
    latitude?: number | null;
    longitude?: number | null;
    title: string;
  }> | null;
};

export type AutocompleteSharryContentsQueryVariables = Types.Exact<{
  text: Types.Scalars['String']['input'];
}>;

export type AutocompleteSharryContentsQuery = {
  __typename?: 'Query';
  results?: Array<
    | {
        __typename?: 'Event';
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        id: string;
      }
    | {
        __typename?: 'Post';
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        id: string;
      }
    | {
        __typename?: 'Sharry';
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        id: string;
      }
    | {
        __typename?: 'Wonder';
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        id: string;
      }
  > | null;
};

export type AutocompleteSearchQueryVariables = Types.Exact<{
  text: Types.Scalars['String']['input'];
  sessionId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  longitude?: Types.InputMaybe<Types.Scalars['String']['input']>;
  latitude?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type AutocompleteSearchQuery = {
  __typename?: 'Query';
  results?: Array<
    | {
        __typename?: 'Event';
        id: string;
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        address?: string | null;
        shortAddress?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
      }
    | { __typename?: 'Hashtag'; id: string; zoom?: number | null; hashtagName: string }
    | {
        __typename?: 'Place';
        isRegion?: boolean | null;
        isProvince?: boolean | null;
        isMunicipality?: boolean | null;
        id: string;
        placeName: string;
      }
    | {
        __typename?: 'Sharry';
        id: string;
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        address?: string | null;
        shortAddress?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
      }
    | {
        __typename?: 'User';
        id: string;
        name?: string | null;
        surname?: string | null;
        workAddress?: string | null;
        isProGold?: boolean | null;
        role: Types.UserRole;
        sharrylandPartner: boolean;
        isSmallOrganisation?: boolean | null;
        anonymised?: boolean | null;
        businessName?: string | null;
        slug?: string | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        address?: string | null;
        shortAddress?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
      }
  > | null;
};

export type TagAutocompleteSearchQueryVariables = Types.Exact<{
  text: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type TagAutocompleteSearchQuery = {
  __typename?: 'Query';
  tagAutocompleteSearch?: Array<
    | {
        __typename?: 'Event';
        id: string;
        slug?: string | null;
        title?: string | null;
        status: Types.SharryContentStatus;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | { __typename?: 'Land' }
    | {
        __typename?: 'Post';
        id: string;
        slug?: string | null;
        title?: string | null;
        status: Types.SharryContentStatus;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | {
        __typename?: 'Sharry';
        id: string;
        slug?: string | null;
        title?: string | null;
        status: Types.SharryContentStatus;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | {
        __typename?: 'User';
        id: string;
        slug?: string | null;
        name?: string | null;
        surname?: string | null;
        businessName?: string | null;
        isSmallOrganisation?: boolean | null;
        isVisible?: boolean | null;
        anonymised?: boolean | null;
        isProGold?: boolean | null;
        role: Types.UserRole;
        sharrylandPartner: boolean;
        image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        title?: string | null;
        status: Types.SharryContentStatus;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
  > | null;
};

export type AutocompletePlacesFragment = {
  __typename?: 'Place';
  id: string;
  name: string;
  isRegion?: boolean | null;
  isProvince?: boolean | null;
  isMunicipality?: boolean | null;
  latitude?: number | null;
  longitude?: number | null;
  title: string;
};

export const AutocompletePlacesFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutocompletePlaces' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Place' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'title' },
            name: { kind: 'Name', value: 'name' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isRegion' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isProvince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMunicipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AutocompleteHashtagsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'autocompleteHashtags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'autocompleteHashtags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'text' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'zoom' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class AutocompleteHashtagsGQL extends Apollo.Query<
  AutocompleteHashtagsQuery,
  AutocompleteHashtagsQueryVariables
> {
  document = AutocompleteHashtagsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const AutocompletePlacesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'autocompletePlaces' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'longitude' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'latitude' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'autocompletePlaces' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'text' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'longitude' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'longitude' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'latitude' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'latitude' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AutocompletePlaces' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutocompletePlaces' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Place' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'title' },
            name: { kind: 'Name', value: 'name' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isRegion' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isProvince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMunicipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class AutocompletePlacesGQL extends Apollo.Query<AutocompletePlacesQuery, AutocompletePlacesQueryVariables> {
  document = AutocompletePlacesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const AutocompleteSharryContentsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'autocompleteSharryContents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'autocompleteSharryContents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'text' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtitle' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class AutocompleteSharryContentsGQL extends Apollo.Query<
  AutocompleteSharryContentsQuery,
  AutocompleteSharryContentsQueryVariables
> {
  document = AutocompleteSharryContentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const AutocompleteSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'autocompleteSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'longitude' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'latitude' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'autocompleteSearchNew' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'text' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'longitude' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'longitude' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'latitude' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'latitude' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Place' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'placeName' },
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRegion' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isProvince' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMunicipality' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'id' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Hashtag' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'hashtagName' },
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'zoom' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharryKind' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nameEn' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workAddress' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isSmallOrganisation' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class AutocompleteSearchGQL extends Apollo.Query<AutocompleteSearchQuery, AutocompleteSearchQueryVariables> {
  document = AutocompleteSearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const TagAutocompleteSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'tagAutocompleteSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '20' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tagAutocompleteSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'text' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isSmallOrganisation' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isVisible' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anonymised' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrySelection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharryKind' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coverPicture' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bestVersion' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'size' },
                                        value: { kind: 'StringValue', value: '160x160', block: false },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class TagAutocompleteSearchGQL extends Apollo.Query<
  TagAutocompleteSearchQuery,
  TagAutocompleteSearchQueryVariables
> {
  document = TagAutocompleteSearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
